import React from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import LazyLoad from "react-lazyload";
const StudentBlog = () => {
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Activity</li>
          <li>Student Blog</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Student Blog</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="blogbox">
                <div className="blogboximg">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/HTSJ/public/Images/Shanu-Kumar.jpg"
                      className="img-fluid"
                      alt=""
                    />
                  </LazyLoad>
                </div>
                <div className="blogboxdesc">
                  <h6>Nothing Is IMPOSSIBLE</h6>
                  <div className="blogboxmsg">
                    {" "}
                    <p>
                      Sometimes, positive thinking quotes are just what the
                      doctor ordered. When times are hard and your heart grows
                      heavy, hearing some words of encouragement or just a
                      little something to make you smile can make a world of
                      difference. Positive thinking has the power to turn a hard
                      day into a manageable one and a good day into an even
                      better one. While a delicious treat is always a good idea,
                      there is something about these inspiring words that feeds
                      the soul in a way that even the best slice of Hummingbird
                      Cake can’t do. So here are some positive thinking quotes
                      that come from the heart that are sure to make a positive
                      impact on your life.
                    </p>
                  </div>
                  <div className="blogboxinfo">
                    <p className="blogname">
                      Shanu Kumar <span>Class : 8</span>
                    </p>
                    <p className="blogdate">Date : 26-10-2023</p>
                  </div>
                </div>
              </div>
              <div className="blogbox">
                <div className="blogboximg">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/HTSJ/public/Images/studentblog.png"
                      className="img-fluid"
                      alt=""
                    />
                  </LazyLoad>
                </div>
                <div className="blogboxdesc">
                  <h6>Depression is under – rated and so are you ! </h6>
                  <div className="blogboxmsg">
                    {" "}
                    <p>
                      Sometimes people in your life will exploit your
                      insecurities, make your wounds bleed. They will mock your
                      voice until you choose to never speak. Your ears will be
                      so accustomed to listening to people?s rants that you will
                      choose to remain silent although having a million things
                      inside you. You might pour your heart out to people who do
                      not care at all. After getting the same mockful response a
                      couple of times, you will stop putting faith in humans.
                      People, whom you call „home? ; will make you feel what
                      homelessness is. As a result, you will try to shut
                      yourself out from people, from the world. Your heart will
                      try to break free from the cage it is caged inside. Your
                      very „close ones? will leave you and you will be on the
                      ground thinking why you were never enough ; you will doubt
                      your capability of loving people. At night, the moon will
                      witness how you crumble down and the darkness in your room
                      will listen to your sobs. Everyone fights sadness in some
                      or the other form. You will somehow pass the night and
                      when morning arrives, you will put up a bright smile like
                      nothing ever happened. The person sitting right next to
                      you will see you smiling not knowing that you?re doing it
                      force your inner demons to shut up. You might feel like
                      you?re fighting like a soldier for better days knowing
                      that it has nearly zero possibility. You will start
                      pretending to be FULL because you?ll be tired of allowing
                      others to drain your soul empty. You will feel like your
                      eyes are covered and your vision is blocked. Your mind
                      will become a terrible place to reside. You will run to
                      some people to take shelter, expecting them to love you
                      and you?ll realise that you could have never been more
                      stupid for they will make fun of your insecurities taking
                      it as lightly as they can. You will feel embarrassed and
                      it?s natural and your perspective for them will forever
                      change. BUT a day will finally come, when you?ll look
                      straight into their eyes and feel nothing. There will be
                      many who will try to shut you down in fear that you will
                      rise up and that exactly will be the time when you should
                      rise up. Leave everything that brings you down and fly as
                      high as you can. Eventually, there will be so many knives
                      stuck inside your bones that even when someone hands you a
                      rose, you will feel more scared of the thorns than being
                      relieved seeing the petals. It takes time, I know ; but
                      you will make it through. It is far harder to live and to
                      fight than it is to give up, which is precisely why you
                      are so strong. Every person who is alive ; is under–rated
                      because it takes a lot to live and to fight than to give
                      up. Don?t you give up ! Yes, depression is real but so is
                      healing. It won?t last long. Your days will come. You will
                      find people who will respect you, your decisions and will
                      never ever just laugh off your insecurities. You will find
                      someone to put your faith in, someone you can rely on.
                      Hold on ! Hold strong ! You are not alone.
                    </p>
                  </div>
                  <div className="blogboxinfo">
                    <p className="blogname">
                      {" "}
                      Poornendu Ranjan Chatterjee{" "}
                      <span> Batch : isc 2018 </span>
                    </p>
                    <p className="blogdate">Date : 02-09-2023</p>
                  </div>
                </div>
              </div>
              <div className="blogbox">
                <div className="blogboximg">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/HTSJ/public/Images/studentblog.png"
                      className="img-fluid"
                      alt=""
                    />
                  </LazyLoad>
                </div>
                <div className="blogboxdesc">
                  <h6>Self Love </h6>
                  <div className="blogboxmsg">
                    {" "}
                    <p>
                      What you think, versus what someone believes, might be
                      oceans apart and in no way, it is meant to bother you.
                      There is passion in love, just as there is passion in
                      hate. What you choose to act on , will reflect back onto
                      you always. Stress, anxiety, fear, anger, depression…
                      whatever shows up, meet it with a warm breath. It?s sad
                      how you forgave people even when they didn?t apologize ;
                      just because you loved them. So, now do yourself a favour
                      and apologize to yourself for being what you were and
                      learn to embrace what you?re transforming into. Learn to
                      walk away the moment you feel you are not being treated
                      the way you should be. I?m not a writer, I?m not a poet,
                      I?m not a story–teller, I?m nothing, I?m nobody and nobody
                      deserves to be treated any less than a human. Now become
                      intimate with your fears. listen to them. sit cross
                      legged. Give them your attention… undivided. Offer them
                      comfort. Offer them rest. It might sound inhuman but the
                      moment your fears become soft, strangle them then and
                      there. You?ve fought so far and trust me you?ll continue
                      to do so. All you need is faith in self. You?ll later
                      realize that you had been carrying this strength all
                      along. When the weight of the world seems to be crashing
                      on your shoulders ; remember that even the cape of a
                      superhero can get heavy at times and you?re just a human.
                      The world you loved fell apart a long time back and you
                      should not be afraid of little things breaking anymore.
                    </p>
                  </div>
                  <div className="blogboxinfo">
                    <p className="blogname">
                      Poornendu Ranjan Chatterjee <span>Batch : isc 2018 </span>
                    </p>
                    <p className="blogdate">Date : 02-09-2023</p>
                  </div>
                </div>
              </div>
              <div className="blogbox">
                <div className="blogboximg">
                  <LazyLoad>
                    <img
                      src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/HTSJ/public/Images/Aditi-Mittal.jpg"
                      className="img-fluid"
                      alt=""
                    />
                  </LazyLoad>
                </div>
                <div className="blogboxdesc">
                  <h6>my dream world </h6>
                  <div className="blogboxmsg">
                    {" "}
                    <p>
                      It was a beautiful Christmas Eve, and my friend Sia called
                      me for a sleepover. In the day time, I had lots of
                      chocolates at home, but I was still craving for more and
                      more. I went to her home, we both enjoyed very much. Like,
                      we did night feast, enjoyed music and did my most
                      favourite thing ‘WE ATE CHOCOLATES’. I was tired and went
                      to sleep. In my dream, I saw a large refrigerator. As I
                      opened it, I saw a beautiful park in it. Its name was
                      ‘PARADISE OF CHOCOLATES’. I went inside. At entrance, I
                      found myself welcomed by a bouquet of sweets. Inside, I
                      was astonished to see the trees decorated with lollipops,
                      a big trampoline of jelly and a huge waterfall of
                      milkshake falling at a corner. I enjoyed the lollipops,
                      jumped higher and higher on trampoline, swam in the pool
                      of milkshake and enjoyed a lot. After all enjoyment, I was
                      feeling very tired and sleepy. At another corner of the
                      park, I saw a gingerbread house. I was welcomed by a dark
                      chocolate giant. He didn’t look very happy so I asked him
                      the reason. He replied “HOHO! I am very hungry. No one has
                      visited me from a long time. HOHO” Surprisingly I asked
                      “Why don’t you enjoy the different flavours in this
                      beautiful park”? He said “HOHO! I don’t like to eat
                      sweets. But I like to eat people who eat sweets. HOHO” He
                      was trying to say that he wants to eat me. As soon as I
                      realised it, I felt very scared and tried to run out of
                      the gingerbread house as fast as I could. But he caught me
                      and I was praying to God. Then I heard a loud voice ‘WAKE
                      UP Dear! MERRY CHRISTMAS”. Sia was petting me to wake me
                      up. Actually it was Christmas Morning and I ended up with
                      my dream world.
                    </p>
                  </div>
                  <div className="blogboxinfo">
                    <p className="blogname">
                      Aditi Mittal <span>Class : 8</span>
                    </p>
                    <p className="blogdate">Date : 28-09-2023</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentBlog;
